/**
 * Type of PartySubID(523) value.
 * - Tag: 803
 * - FIX Specification type: int
 * - Mapped type: number
 * @readonly
 * @public
 */
export const PartySubIDType = Object.freeze({
    /** Firm */
    Firm: 1,
    /** Person */
    Person: 2,
    /** System */
    System: 3,
    /** Application */
    Application: 4,
    /** Full legal name of firm */
    FullLegalNameOfFirm: 5,
    /** Postal address */
    PostalAddress: 6,
    /** Phone number */
    PhoneNumber: 7,
    /** Email address */
    EmailAddress: 8,
    /** Contact name */
    ContactName: 9,
    /** Securities account number (for settlement instructions) */
    SecuritiesAccountNumber: 10,
    /** Registration number (for settlement instructions and confirmations) */
    RegistrationNumber: 11,
    /** Registered address (for confirmation purposes) */
    RegisteredAddressForConfirmation: 12,
    /** Regulatory status (for confirmation purposes) */
    RegulatoryStatus: 13,
    /** Registration name (for settlement instructions) */
    RegistrationName: 14,
    /** Cash account number (for settlement instructions) */
    CashAccountNumber: 15,
    /** BIC */
    BIC: 16,
    /** CSD participant member code */
    CSDParticipantMemberCode: 17,
    /** Registered address */
    RegisteredAddress: 18,
    /** Fund account name */
    FundAccountName: 19,
    /** Telex number */
    TelexNumber: 20,
    /** Fax number */
    FaxNumber: 21,
    /** Securities account name */
    SecuritiesAccountName: 22,
    /** Cash account name */
    CashAccountName: 23,
    /** Department */
    Department: 24,
    /** Location desk */
    LocationDesk: 25,
    /** Position account type */
    PositionAccountType: 26,
    /** Security locate ID */
    SecurityLocateID: 27,
    /** Market maker */
    MarketMaker: 28,
    /** Eligible counterparty */
    EligibleCounterparty: 29,
    /** Professional client */
    ProfessionalClient: 30,
    /** Location */
    Location: 31,
    /** Execution venue */
    ExecutionVenue: 32,
    /** Currency delivery identifier */
    CurrencyDeliveryIdentifier: 33,
    /** Address City */
    AddressCity: 34,
    /** Address State/Province */
    AddressStateOrProvince: 35,
    /** Address Postal Code */
    AddressPostalCode: 36,
    /** Address Street */
    AddressStreet: 37,
    /** Address Country (ISO country code) */
    AddressISOCountryCode: 38,
    /** ISO country code */
    ISOCountryCode: 39,
    /** Market segment */
    MarketSegment: 40,
    /** Customer account type */
    CustomerAccountType: 41,
    /** Omnibus account */
    OmnibusAccount: 42,
    /** Funds segregation type */
    FundsSegregationType: 43,
    GuaranteeFund: 44,
    SwapDealer: 45,
    MajorParticipant: 46,
    FinancialEntity: 47,
    USPerson: 48,
    ReportingEntityIndicator: 49,
    /** Elected clearing requirement exception */
    ElectedClearingRequirementException: 50,
    BusinessCenter: 51,
    /** Reference text */
    ReferenceText: 52,
    /** Short-marking exempt account */
    ShortMarkingExemptAccount: 53,
    ParentFirmIdentifier: 54,
    ParentFirmName: 55,
    DealIdentifier: 56,
    /** System trade identifier */
    SystemTradeID: 57,
    /** System trade sub-identifier */
    SystemTradeSubID: 58,
    FCMCode: 59,
    DlvryTrmlCode: 60,
    VolntyRptEntity: 61,
    RptObligJursdctn: 62,
    VolntyRptJursdctn: 63,
    CompanyActivities: 64,
    EEAreaDomiciled: 65,
    ContractLinked: 66,
    ContractAbove: 67,
    VolntyRptPty: 68,
    EndUser: 69,
    LocationOrJurisdiction: 70,
    DerivativesDealer: 71,
    Domicile: 72,
    ExemptFromRecognition: 73,
    Payer: 74,
    Receiver: 75,
    SystematicInternaliser: 76,
    PublishingEntityIndicator: 77,
    FirstName: 78,
    Surname: 79,
    DateOfBirth: 80,
    OrderTransmittingFirm: 81,
    OrderTransmittingFirmBuyer: 82,
    OrderTransmitterSeller: 83,
    /** Legal Entity Identifier (ISO 17442) LEI */
    LegalEntityIdentifier: 84,
    SubSectorClassification: 85,
    PartySide: 86,
    LegalRegistrationCountry: 87,
} as const);

export type PartySubIDType = (typeof PartySubIDType)[keyof typeof PartySubIDType];
